/**
 * Tanstack React Query Exports
 *
 * This file exports Tanstack React Query functionality globally
 * so it can be used by other scripts in the WordPress environment.
 */

import { QueryClient } from '@tanstack/react-query';

// Re-export everything from react-query as-is
export * from '@tanstack/react-query';

// Create and export a default query client instance
export const defaultQueryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 1000 * 60 * 5, // 5 minutes
			gcTime: 1000 * 60 * 30, // 30 minutes (formerly cacheTime)
			retry: 1,
			refetchOnWindowFocus: false,
		},
	},
});
